import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Col,
    Container,
    Form,
    Image,
    InputGroup,
    Modal,
    Row,
    Stack,
} from 'react-bootstrap';
import BgImage from '../../Assets/Img/login_bg.png';
import Logo from '../../Assets/Img/logo.svg';
import './login.scss';
import { useLocation, useNavigate } from 'react-router';
import LoadingComponent from '../LoadingComponent';
import {
    useChangePasswordMutation,
    useForgotPasswordMutation,
} from './loginApi';
import { useTranslation } from 'react-i18next';
import { validatePassword } from '../../helper';
import { Eye, EyeOff } from 'lucide-react';

const ForgotPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [loginConfig, setLoginConfig] = useState({ email: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [passwordValidation, setPasswordValidation] = useState('');
    const [passwordChangeConfig, setPasswordChangeConfig] = useState({
        newPassword: '',
        confirmNewPassword: '',
    });

    const [successMessage, setSuccessMessage] = useState(false);

    const location = useLocation();
    const searchParam = location?.search;

    const [forgotPassword] = useForgotPasswordMutation();
    const [passwordChange] = useChangePasswordMutation();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const changeHandle = (e) => {
        if (!searchParam) {
            setLoginConfig((prevValue) => {
                return {
                    ...prevValue,
                    [e.target.name]: e.target.value,
                };
            });
        } else {
            setPasswordChangeConfig((prevValues) => {
                return {
                    ...prevValues,
                    [e.target.name]: e.target.value,
                };
            });
        }
    };

    const submitHandle = async () => {
        try {
            setError('');
            setSuccessMessage(false);
            setLoading(true);
            await forgotPassword(loginConfig).then(async (data) => {
                console.log(data);

                if (data.error.data !== 'success') {
                    setError(data.error.data);
                    setSuccessMessage(false);
                }
                if (data.error.data == 'success') {
                    setSuccessMessage(true);
                    setError('');
                }
            });
        } catch (error) {
            console.error(
                'Login failed:',
                error.response?.data || error.message
            );
        } finally {
            setLoading(false);
        }
    };

    const changePassword = async () => {
        setLoading(true);
        setError('');
        if (!validatePassword(passwordChangeConfig?.newPassword)) {
            setPasswordValidation(t('passwordValidation'));
            return;
        }
        if (
            passwordChangeConfig?.newPassword !==
            passwordChangeConfig?.confirmNewPassword
        ) {
            setPasswordMatchError(t('passwordNotMatch'));
            setPasswordValidation(t(''));
            return;
        }
        // setButtonLoading(true);
        setPasswordMatchError(t(''));
        setPasswordValidation(t(''));
        console.log(passwordChangeConfig, 'passwordChangeConfig');

        let result = await passwordChange({
            emailId: searchParam.replace(/\?/g, ''),
            newPassword: passwordChangeConfig.newPassword,
        });
        console.log(result.error.data);
        if (result.error.data !== 'success') {
            setError(result.error.data);
            // setButtonLoading(false)
        }
        if (result.error.data == 'success') {
            setLoading(false);
            navigate('/login');
        }
    };

    return (
        <>
            <Container fluid className="login_wrapper">
                <LoadingComponent loading={loading} />
                <Row>
                    <Col
                        lg={8}
                        style={{ backgroundImage: `url(${BgImage})` }}
                        className="login_left_wrapper"
                    ></Col>
                    <Col lg={4} className="login_right_wrapper">
                        <div className="login_right_wrapper_inner">
                            <Stack gap={3}>
                                <div>
                                    <div className="login_logo">
                                        <Image src={Logo} />
                                    </div>
                                    {!searchParam ? (
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                submitHandle();
                                            }}
                                        >
                                            <h3>Mot de passe oublié ?</h3>
                                            <Form.Group
                                                controlId="formGridEmail"
                                                className=""
                                            >
                                                <Form.Label>
                                                    Identifiant / Email
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Votre identifiant ou email"
                                                    name="email"
                                                    value={loginConfig.email}
                                                    onChange={changeHandle}
                                                    required
                                                />
                                            </Form.Group>
                                            {error !== '' && (
                                                <Alert
                                                    variant={'danger'}
                                                    className="mt-4"
                                                >
                                                    Malheureusement, nous
                                                    n'avons pas trouvé de compte
                                                    avec cette adresse e-mail.
                                                </Alert>
                                            )}
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                className="w-100"
                                            >
                                                Réinitialiser le mot de passe
                                            </Button>
                                            {successMessage && (
                                                <Alert
                                                    variant={'success'}
                                                    className="mt-3"
                                                >
                                                    Merci de vérifier votre boîte de réception.
                                                </Alert>
                                            )}
                                        </Form>
                                    ) : (
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                changePassword();
                                            }}
                                        >
                                            <h3>
                                                Définissez votre nouveau mot de
                                                passe 🔒
                                                <br />
                                                Bienvenue
                                            </h3>
                                            <Form.Group
                                                controlId="formGridEmail"
                                                className="mb-4"
                                            >
                                                <Form.Label>
                                                    nouveau mot de passe
                                                </Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type={
                                                            showPassword
                                                                ? 'text'
                                                                : 'password'
                                                        }
                                                        name="newPassword"
                                                        value={
                                                            passwordChangeConfig.newPassword
                                                        }
                                                        onChange={changeHandle}
                                                        required
                                                    />
                                                    <InputGroup.Text
                                                        onClick={
                                                            togglePasswordVisibility
                                                        }
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {showPassword ? (
                                                            <Eye />
                                                        ) : (
                                                            <EyeOff />
                                                        )}
                                                    </InputGroup.Text>
                                                </InputGroup>

                                                {passwordValidation !== '' && (
                                                    <Form.Text className="text-danger">
                                                        {passwordValidation}
                                                    </Form.Text>
                                                )}
                                            </Form.Group>
                                            <Form.Group
                                                controlId="formGridEmail"
                                                className=""
                                            >
                                                <Form.Label>
                                                    Re-taper le nouveau mot de
                                                    passe
                                                </Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type={
                                                            showPassword
                                                                ? 'text'
                                                                : 'password'
                                                        }
                                                        name="confirmNewPassword"
                                                        value={
                                                            passwordChangeConfig.confirmNewPassword
                                                        }
                                                        onChange={changeHandle}
                                                        required
                                                    />
                                                    <InputGroup.Text
                                                        onClick={
                                                            togglePasswordVisibility
                                                        }
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {showPassword ? (
                                                            <Eye />
                                                        ) : (
                                                            <EyeOff />
                                                        )}
                                                    </InputGroup.Text>
                                                </InputGroup>

                                                {passwordMatchError !== '' && (
                                                    <Form.Text className="text-danger">
                                                        {passwordMatchError}
                                                    </Form.Text>
                                                )}
                                            </Form.Group>
                                            {error !== '' && (
                                                <Alert
                                                    variant={'danger'}
                                                    className="mt-4"
                                                >
                                                    {error}
                                                </Alert>
                                            )}

                                            <Button
                                                variant="primary"
                                                type="submit"
                                                className="w-100"
                                            >
                                                Définir le mot de passe
                                            </Button>
                                        </Form>
                                    )}

                                    <Stack direction="horizontal" gap={3}>
                                        <div className="m-auto">
                                            <Button
                                                variant="link"
                                                onClick={() =>
                                                    navigate('/login')
                                                }
                                            >
                                                Retour à l'écran de connexion
                                            </Button>
                                        </div>
                                    </Stack>
                                </div>
                                <div className="copyright mt-auto text-center">
                                    © Sym Tech - 2026
                                </div>
                            </Stack>
                        </div>
                    </Col>
                </Row>
                <LoadingComponent loading={loading} />
            </Container>
        </>
    );
};
export default ForgotPassword;
